/**
 * TanStack Query hooks for `igaming-player-ltv-per-affiliate-advanced`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingPlayerLtvPerAffiliateAdvancedQueryKeys,
	type CreateIgamingPlayerLtvPerAffiliateAdvancedBody,
	type ListIgamingPlayerLtvPerAffiliateAdvancedResponse,
	type IgamingPlayerLtvPerAffiliateAdvancedRow,
} from "./api";

export function useIgamingPlayerLtvPerAffiliateAdvancedList(): UseQueryResult<ListIgamingPlayerLtvPerAffiliateAdvancedResponse, Error> {
	return useQuery({
		queryKey: igamingPlayerLtvPerAffiliateAdvancedQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingPlayerLtvPerAffiliateAdvancedCreate(): UseMutationResult<IgamingPlayerLtvPerAffiliateAdvancedRow, Error, CreateIgamingPlayerLtvPerAffiliateAdvancedBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingPlayerLtvPerAffiliateAdvancedQueryKeys.all });
		},
	});
}

export function useIgamingPlayerLtvPerAffiliateAdvancedDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingPlayerLtvPerAffiliateAdvancedQueryKeys.all });
		},
	});
}
